import React from 'react';
import ContentLoader from 'react-content-loader';

import css from './Loader.module.scss';

export const Loader = () => {
  return (
    <div className={css.loader}>
      <ContentLoader
        speed={2}
        width={331}
        height={420}
        viewBox="0 0 331 420"
        backgroundColor="#edede0"
        foregroundColor="#dbdbcc"
      >
        <circle cx="579" cy="533" r="15" />
        <rect x="512" y="523" rx="2" ry="2" width="140" height="10" />
        <rect x="487" y="542" rx="2" ry="2" width="140" height="10" />
        <rect x="-2" y="49" rx="10" ry="10" width="329" height="207" />
        <rect x="577" y="531" rx="0" ry="0" width="9" height="22" />
        <rect x="0" y="2" rx="10" ry="10" width="328" height="23" />
        <rect x="14" y="279" rx="10" ry="10" width="313" height="15" />
        <rect x="41" y="306" rx="10" ry="10" width="286" height="15" />
        <rect x="213" y="341" rx="10" ry="10" width="112" height="24" />
        <rect x="133" y="341" rx="10" ry="10" width="76" height="24" />
        <rect x="1" y="383" rx="10" ry="10" width="327" height="35" />
      </ContentLoader>
    </div>
  );
};
